import { render } from "./ProjectCommentItem.vue?vue&type=template&id=241e698a"
import script from "./ProjectCommentItem.vue?vue&type=script&lang=js"
export * from "./ProjectCommentItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__